import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const CardSplit = () => {
  return <ObsIframe path="/update-card-split" />;
};

export default React.memo(CardSplit);
